"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileSize = void 0;
var FileSize_1 = require("./FileSize");
Object.defineProperty(exports, "FileSize", { enumerable: true, get: function () { return __importDefault(FileSize_1).default; } });
//# sourceMappingURL=index.js.map